
import { repository } from 'jtech'

export const SendEmailSmsRepository = {

  nmInterfaceSearshSendEmailSms: 'sendEmailSms.pesquisar',
  nmInterfaceGravarSendEmailSms: 'sendEmailSms.gravar',

  loadDatatable: async function () {
    const dada = await repository.resolveDatatable(this.nmInterfaceSearshSendEmailSms)
    return dada
  },

  async loadDatatableModel (params) {
    return await repository.resolveDatatableModel(this.nmInterfaceSearshSendEmailSms, { ...params })
  },

  loadForm: async function () {
    return await repository.resolve(this.nmInterfaceGravarSendEmailSms)
  },

  create: async function (params) {
    return await repository.create(this.nmInterfaceGravarSendEmailSms, params)
  }
}
